import { Shield, UserRound, Building2, PawPrint } from "lucide-react";
import { Link } from "react-router-dom";
import { useAuth } from "@/hooks/useAuth";
import { Brand } from "./Brand";

export const Header = () => {
  const { user, loading, isAdmin } = useAuth();

  return (
    <header className="sticky top-0 z-[1200] bg-card/90 backdrop-blur-md border-b border-border px-3 py-2 sm:px-6 sm:py-4 flex items-center justify-between gap-2 sm:gap-3">
      <a
        href="https://gdzieschronisko.pl/"
        className="flex items-center gap-2 sm:gap-3 w-fit rounded-lg outline-none focus-visible:ring-2 focus-visible:ring-primary"
        aria-label="Strona główna GdzieSchronisko"
      >
        <span className="bg-primary rounded-lg flex items-center justify-center w-8 h-8 sm:w-10 sm:h-10 shrink-0">
          <PawPrint className="text-primary-foreground w-4 h-4 sm:w-5 sm:h-5" />
        </span>
        <span className="flex flex-col leading-none">
          <Brand size="md" />
          <span className="hidden sm:inline text-[8px] font-semibold uppercase text-muted-foreground/70 leading-none mt-0" style={{ letterSpacing: "0.16em" }}>
            Mapa pomocy dla zwierząt
          </span>
        </span>

      </a>



      <div className="flex items-center gap-3">
        {isAdmin && (
          <Link
            to="/admin"
            className="inline-flex items-center gap-1.5 text-xs font-semibold text-primary bg-primary/10 hover:bg-primary/20 px-2.5 py-1 rounded-md transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary"
            aria-label="Panel admina"
          >
            <Shield className="w-3.5 h-3.5" />
            Admin
          </Link>
        )}
        {!loading && user && (
          <Link
            to="/panel"
            className="inline-flex items-center gap-1.5 text-xs font-medium text-foreground/70 hover:text-primary hover:bg-primary/5 px-2.5 py-1 rounded-full border border-border hover:border-primary/30 transition-colors outline-none focus-visible:ring-2 focus-visible:ring-primary/20"
            aria-label="Panel organizacji"
          >
            <Building2 className="w-3.5 h-3.5" />
            <span className="hidden sm:inline">Panel organizacji</span>
            <span className="sm:hidden">Panel</span>
          </Link>
        )}
        {!loading && !user && (
          <Link
            to="/logowanie"
            className="inline-flex items-center gap-1.5 text-xs font-medium text-muted-foreground hover:text-primary hover:border-primary/40 hover:bg-primary/5 px-2.5 py-1 rounded-full border border-primary/20 transition-colors outline-none focus-visible:ring-2 focus-visible:ring-primary/20 focus-visible:border-primary/40"
          >
            <UserRound className="w-3.5 h-3.5" />
            Zaloguj się
          </Link>
        )}
      </div>
    </header>
  );
};
